import { render, staticRenderFns } from "./PayableRateDetailDetailByRute.vue?vue&type=template&id=ffaa67a6&scoped=true"
import script from "./PayableRateDetailDetailByRute.vue?vue&type=script&lang=js"
export * from "./PayableRateDetailDetailByRute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffaa67a6",
  null
  
)

export default component.exports